import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=f38455bc&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=f38455bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f38455bc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f38455bc')) {
      api.createRecord('f38455bc', component.options)
    } else {
      api.reload('f38455bc', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=f38455bc&scoped=true&", function () {
      api.rerender('f38455bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2IJQoFAwdH7Gu/JS/comp/DocBox.vue"
export default component.exports